import { IRootState } from '../reducer'
import { prefix } from './actions'

export const phoneNumbers = (state: IRootState) => state[prefix].phoneNumbers

export const availableNumbers = (state: IRootState) => state[prefix].availableNumbers

/** The unfiltered pool, for the messages feed's Number dropdown. */
export const numberOptions = (state: IRootState) => state[prefix].numberOptions

export const messages = (state: IRootState) => state[prefix].messages

/** Every code received across the pool — the list under the numbers table. */
export const allMessages = (state: IRootState) => state[prefix].allMessages

/** Which number the loaded `messages` came from — see the reducer. */
export const messagesFor = (state: IRootState) => state[prefix].messagesFor

export const lastMessagesParams = (state: IRootState) => state[prefix].lastMessagesParams

export const lastAllMessagesParams = (state: IRootState) => state[prefix].lastAllMessagesParams
